import React from 'react';
import { Redirect } from 'react-router-dom';

import PortCancelForm from 'components/PortCancelForm';

const PortCancel = ({
  subId,
  submitSucceeded,
  sub,
  onSuccessRedirectUrl,
  SubNav,
  ...props
}) => {
  if (!sub) {
    return <div>Loading...</div>;
  }

  if (submitSucceeded) {
    return <Redirect to={onSuccessRedirectUrl(subId)} />;
  }

  return (
    <div>
      <h1>Cancel Port</h1>
      <SubNav />
      <br />
      <PortCancelForm {...props} />
    </div>
  );
};

export default PortCancel;
